import { render, staticRenderFns } from "./UserManagementDetail.vue?vue&type=template&id=706bcbce&scoped=true"
import script from "./UserManagementDetail.vue?vue&type=script&lang=js"
export * from "./UserManagementDetail.vue?vue&type=script&lang=js"
import style0 from "./UserManagementDetail.vue?vue&type=style&index=0&id=706bcbce&prod&lang=scss&scoped=scoped"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "706bcbce",
  null
  
)

export default component.exports